/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Input,
  Label,
  Segment,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import config from '../../config';
import { fetchAffiliateMappings } from '../actions/affiliateMappings';
import { fetchProjectMappings } from '../actions/projectMappings';
import { fetchProjectOptions } from '../actions/projectOptions';
import { fetchProjectSpecifications } from '../actions/projectSpecifications';
import { fetchProjectUnitLayoutSpecifications } from '../actions/projectUnitLayoutSpecifications';
import { fetchProjectUnitSpecifications } from '../actions/projectUnitSpecifications';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { visibleLayoutSpecifications } from '../utils/unitLayout';

const isPRS = config.get('prs');

class SpecificationTable extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    type: PropTypes.oneOf(['projects', 'unit_layouts', 'units', 'bookings', 'projectOptions', 'customOptions', 'projectMappings', 'affiliateMappings']).isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    onAdd: PropTypes.func,
    notFoundNode: PropTypes.node,
    headerNode: PropTypes.string,
    headerButtonNode: PropTypes.string,
    isEditing: PropTypes.bool,
    onChange: PropTypes.func,
    buttonNode: PropTypes.func,
    cancelNode: PropTypes.func,
    onClick: PropTypes.func,
    onCancel: PropTypes.func,
    editable: PropTypes.bool,
    loading: PropTypes.bool,
    hideButton: PropTypes.bool,
    placeholderName: PropTypes.string,
    placeholderDescription: PropTypes.string,
    affiliateMappings: PropTypes.shape({
      data: PropTypes.array,
    }),
    projectMappings: PropTypes.shape({
      data: PropTypes.array,
    }),
    projectOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    projectSpecifications: PropTypes.shape({
      data: PropTypes.array,
    }),
    projectUnitLayoutSpecifications: PropTypes.shape({
      data: PropTypes.array,
    }),
    projectUnitSpecifications: PropTypes.shape({
      data: PropTypes.array,
    }),
    // CPI-1208 (Q4): only used to decide whether the five Vietnam layout presets are offered.
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    tableStyle: PropTypes.oneOfType([PropTypes.object]),
    newHeader: PropTypes.string,
    isCollapsible: PropTypes.bool,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    affiliateMappings: state.affiliateMappings,
    projectMappings: state.projectMappings,
    projectOptions: state.projectOptions,
    projectSpecifications: state.projectSpecifications,
    projectUnitLayoutSpecifications: state.projectUnitLayoutSpecifications,
    projectUnitSpecifications: state.projectUnitSpecifications,
  })
  constructor(props) {
    super(props);
    const affiliateMappings = props.affiliateMappings ?
      [].concat(props.affiliateMappings.data) : [];
    const projectMappings = props.projectMappings ?
      [].concat(props.projectMappings.data) : [];
    const projectOptions = props.projectOptions ?
      [].concat(props.projectOptions.data) : [];
    const projectSpecifications = props.projectSpecifications ?
      [].concat(props.projectSpecifications.data) : [];
    const projectUnitLayoutSpecifications = props.projectUnitLayoutSpecifications ?
      [].concat(props.projectUnitLayoutSpecifications.data) : [];
    const projectUnitSpecifications = props.projectUnitSpecifications ?
      [].concat(props.projectUnitSpecifications.data) : [];
    let options = [];
    if (props.type) {
      switch (props.type) {
        case 'affiliateMappings':
          options = affiliateMappings.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projectMappings':
          options = projectMappings.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projectOptions':
          options = projectOptions.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projects':
          options = projectSpecifications.map(d => this.setPreset(d.name, 'blue'));
          break;
        // CPI-1208 (Q4): the five Vietnam presets are seeded rows on a table with no company
        // column, so they are filtered out for every company that is not Vietnamese.
        case 'unit_layouts':
          options = visibleLayoutSpecifications(props.auth, projectUnitLayoutSpecifications)
            .map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'units':
          options = projectUnitSpecifications.map(d => this.setPreset(d.name, 'blue'));
          break;
        default:
          options = [];
      }
    }
    const data = props.data ? [].concat(props.data) : [];
    if (data.length > 0) {
      options = options.concat(...data.map(d => this.setPreset(d.name)))
      .filter((d, idx, arr) => idx === arr.findIndex(f => f.text === d.text) && d.text.length > 0);
    }
    const isEditing = false || props.isEditing;
    this.state = {
      options,
      data,
      hideTab: false,
      isEditing,
      affiliateMappings,
      projectMappings,
      projectOptions,
      projectSpecifications,
      projectUnitLayoutSpecifications,
      projectUnitSpecifications,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    if (isPRS) store.dispatch(fetchProjectOptions(false));
    store.dispatch(fetchProjectSpecifications(false));
    store.dispatch(fetchProjectUnitLayoutSpecifications(false));
    store.dispatch(fetchProjectUnitSpecifications(false));
    store.dispatch(fetchAffiliateMappings(false));
    store.dispatch(fetchProjectMappings(false));
  }
  componentWillReceiveProps(nextProps) {
    const affiliateMappings = nextProps.affiliateMappings ?
      [].concat(nextProps.affiliateMappings.data) : this.state.affiliateMappings;
    const projectMappings = nextProps.projectMappings ?
      [].concat(nextProps.projectMappings.data) :
      this.state.projectMappings;
    const projectOptions = nextProps.projectOptions ?
      [].concat(nextProps.projectOptions.data) : this.state.projectOptions;
    const projectSpecifications = nextProps.projectSpecifications ?
      [].concat(nextProps.projectSpecifications.data) : this.state.projectSpecifications;
    const projectUnitLayoutSpecifications = nextProps.projectUnitLayoutSpecifications ?
      [].concat(nextProps.projectUnitLayoutSpecifications.data) :
      this.state.projectUnitLayoutSpecifications;
    const projectUnitSpecifications = nextProps.projectUnitSpecifications ?
      [].concat(nextProps.projectUnitSpecifications.data) :
      this.state.projectUnitSpecifications;
    let options = [];
    if (nextProps.type) {
      switch (nextProps.type) {
        case 'affiliateMappings':
          options = affiliateMappings.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projectMappings':
          options = projectMappings.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projectOptions':
          options = projectOptions.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'projects':
          options = projectSpecifications.map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'unit_layouts':
          options = visibleLayoutSpecifications(nextProps.auth, projectUnitLayoutSpecifications)
            .map(d => this.setPreset(d.name, 'blue'));
          break;
        case 'units':
          options = projectUnitSpecifications.map(d => this.setPreset(d.name, 'blue'));
          break;
        default:
          options = [];
      }
    }
    const data = nextProps.data ? [].concat(nextProps.data) : [];
    if (data.length > 0) {
      options = options.concat(...data.map(d => this.setPreset(d.name)))
      .filter((d, idx, arr) => idx === arr.findIndex(f => f.text === d.text) && d.text.length > 0);
    }
    if (nextProps.editable) {
      const isEditing = nextProps.isEditing;
      if (isEditing !== undefined) {
        this.setState({ isEditing });
      }
    }
    this.setState({
      data,
      options,
      affiliateMappings,
      projectMappings,
      projectOptions,
      projectSpecifications,
      projectUnitLayoutSpecifications,
      projectUnitSpecifications,
    });
  }
  setPreset = (value, color = null) => ({
    text: value,
    value,
    label: { color, empty: true, circular: true },
  })
  getColSpan = (row, idx, rows) => {
    let colSpan = 0;
    for (let i = idx; i < rows.length; i += 1) {
      if (rows[i].name !== row.name) {
        break;
      }
      colSpan += 1;
    }
    if (colSpan > 0) {
      return colSpan;
    }
    return null;
  }
  handleOnClick = (e) => {
    if (this.props.onAdd) {
      this.props.onAdd(e);
    }
  }
  handleInputSpecifications = (d, idx, key) => {
    const {
      data,
      affiliateMappings,
      projectMappings,
      projectOptions,
      projectSpecifications,
      projectUnitLayoutSpecifications,
      projectUnitSpecifications,
    } = this.state;
    data[idx][key] = d.value;
    if (key === 'name') {
      if (this.props.type) {
        let ps;
        switch (this.props.type) {
          case 'affiliateMappings':
            ps = affiliateMappings.find(p => p.name === d.value);
            break;
          case 'projectMappings':
            ps = projectMappings.find(p => p.name === d.value);
            break;
          case 'projectOptions':
            ps = projectOptions.find(p => p.name === d.value);
            break;
          case 'unit_layouts':
            ps = projectUnitLayoutSpecifications.find(p => p.name === d.value);
            break;
          case 'units':
            ps = projectUnitSpecifications.find(p => p.name === d.value);
            break;
          case 'projects':
          default:
            ps = projectSpecifications.find(p => p.name === d.value);
        }
        data[idx].shortName = ps ? ps.shortName : '';
        data[idx].description = ps ? ps.description : '';
      }
    }
    this.handleOnChange(data);
  }
  handleAddRow = () => {
    const { data } = this.state;
    data.push({
      name: '',
      shortName: '',
      description: '',
      value: '',
      position: data.length + 1 || 1,
    });
    this.handleOnChange(data);
  }
  handleRemoveRow = (idx) => {
    const { data } = this.state;
    data.splice(idx, 1);
    this.handleOnChange(data);
  }
  handleMoveRow = (idx, row, incre) => {
    const { data } = this.state;
    if (idx + incre >= 0 && idx + incre < data.length) {
      data.splice(idx, 1);
      data.splice(idx + incre, 0, row);
    }
    data.forEach((d, index) => {
      data[index].position = index + 1;
    });
    this.handleOnChange(data);
  }
  handleOnChange(data) {
    this.setState({ data });
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  }
  checkIsEditing() {
    return this.props.editable && this.state.isEditing;
  }
  handleOnConfirm = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (this.props.editable) {
      const isEditing = !this.state.isEditing;
      this.setState({ isEditing }, () => {
        if (!isEditing) {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        }
      });
    } else if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  handleOnCancel = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (this.props.editable) {
      const isEditing = false;
      this.setState({ isEditing }, () => {
        if (this.props.onCancel) {
          this.props.onCancel(e);
        }
      });
    }
  }
  handleOnCollapseSegment = (e) => {
    e.preventDefault();
    this.setState({ hideTab: !this.state.hideTab });
  }
  handleAddition = (e, { value }) => {
    if (value) {
      this.setState({
        options: [this.setPreset(value), ...this.state.options],
      });
    }
  }
  renderRow() {
    const { data } = this.state;
    const { t } = this.props;
    if (this.checkIsEditing()) {
      if (data.length > 0) {
        return data.map((row, idx) => (
          <Table.Row key={idx}>
            <Table.Cell collapsing>
              <Button.Group vertical size="mini" compact>
                <Button
                  type="button"
                  icon="chevron up"
                  disabled={idx === 0}
                  onClick={() => this.handleMoveRow(idx, row, -1)}
                />
                <Button
                  type="button"
                  icon="chevron down"
                  disabled={idx + 1 === data.length}
                  onClick={() => this.handleMoveRow(idx, row, 1)}
                />
              </Button.Group>
            </Table.Cell>
            <Table.Cell width={16}>
              <Dropdown
                options={this.state.options}
                placeholder={this.props.placeholderName || t('Enter / select specification')}
                search
                selection
                fluid
                allowAdditions
                additionLabel={t('Add') + ' '}
                value={row.name}
                onAddItem={this.handleAddition}
                onChange={(e, d) => this.handleInputSpecifications(d, idx, 'name')}
                selectOnBlur={false}
                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
              />
              <Input
                placeholder={this.props.placeholderDescription || t('Enter description')}
                fluid
                value={row.value}
                onChange={(e, d) => this.handleInputSpecifications(d, idx, 'value')}
              />
            </Table.Cell>
            <Table.Cell collapsing>
              <Button
                floated="right"
                negative
                type="button"
                size="small"
                icon="trash"
                onClick={() => this.handleRemoveRow(idx)}
              />
            </Table.Cell>
          </Table.Row>
        ));
      }
      return (
        <Table.Row>
          <Table.Cell colSpan="3" textAlign="center">
            {this.props.notFoundNode || <p>{t('No specifications set')}.</p>}
          </Table.Cell>
        </Table.Row>
      );
    }
    if (data.length > 0) {
      return data.map((row, idx, rows) => (
        <Table.Row key={idx} title={row.description || null}>
          {
            idx > 0 && rows[idx - 1].name === row.name ? null
            : (
              <Table.Cell
                width={5}
                rowSpan={this.getColSpan(row, idx, rows)}
              >
                {row.name}
              </Table.Cell>
          )}
          <Table.Cell>{row.value}</Table.Cell>
        </Table.Row>
      ));
    }
    return (
      <Table.Row>
        <Table.Cell colSpan="2" textAlign="center">
          <Segment textAlign="center" vertical>
            {this.props.notFoundNode || <p>{t('No specifications set')}.</p>}
            {
              !this.checkIsEditing() && this.props.onAdd ?
                <Button
                  as="a"
                  primary compact
                  disabled={this.props.loading}
                  onClick={this.handleOnClick}
                >
                  {t('Click here to add')}
                </Button>
              : null
            }
          </Segment>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const { newHeader, isCollapsible, t } = this.props;
    const { hideTab } = this.state;
    return (
      <div>
        {
          newHeader ? (
            <Header className="new_title" as="h5" attached="top" textAlign="center">
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16} textAlign="center">
                    {newHeader}
                  </Grid.Column>
                  {
                    isCollapsible ? (
                      <Label
                        as="button"
                        attached="top right"
                        icon={hideTab ? 'angle up' : 'angle down' }
                        className="collapse-button"
                        style={{
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em',
                        }}
                        onClick={this.handleOnCollapseSegment}
                        disabled={this.props.loading}
                      />
                    ) : null
                  }
                </Grid.Row>
              </Grid>
            </Header>
          ) : null
        }
        {
          newHeader && !hideTab ? (
            <Segment attached>
              <Table
                style={this.props.tableStyle || {}}
                celled striped unstackable
                structured={!this.checkIsEditing()}
                selectable={this.checkIsEditing()}
                compact={this.checkIsEditing()}
              >
                {
                  this.props.editable ?
                    <Table.Header fullWidth>
                      <Table.Row>
                        {
                          this.props.hideButton ? (
                            <Table.HeaderCell colSpan={2}>
                              {this.props.headerNode || t('Specifications')}
                            </Table.HeaderCell>
                          ) : (
                            <Table.HeaderCell colSpan={2}>
                              {(this.props.headerButtonNode && !this.state.isEditing)
                                && this.props.headerButtonNode
                              }
                              {
                                this.props.cancelNode && this.checkIsEditing() ?
                                this.props.cancelNode({
                                  isEditing: this.state.isEditing,
                                  onClick: this.handleOnCancel,
                                }) : null
                              }
                              {
                                !this.props.cancelNode && this.checkIsEditing() ? (
                                  <Button
                                    as="a"
                                    size="small"
                                    floated="left"
                                    compact
                                    icon="remove"
                                    content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                                    onClick={this.handleOnCancel}
                                    disabled={this.props.loading}
                                  />
                                ) : null
                              }
                              {
                                this.props.buttonNode && this.props.editable ?
                                this.props.buttonNode({
                                  isEditing: this.state.isEditing,
                                  onClick: this.handleOnConfirm,
                                }) : null
                              }
                              {
                                !this.props.buttonNode && this.props.editable ? (
                                  <Button
                                    as="a"
                                    size="small"
                                    floated="right"
                                    compact
                                    onClick={this.handleOnConfirm}
                                    icon={this.checkIsEditing() ? 'save' : 'pencil'}
                                    color={this.checkIsEditing() ? 'blue' : null}
                                    content={t(this.checkIsEditing() ? 'Update' : 'Edit', { ns: TRANSLATION_FILES.translation })}
                                    disabled={this.props.loading}
                                  />
                                ) : null
                              }
                            </Table.HeaderCell>
                        )}
                        {
                          this.checkIsEditing() ? (
                            <Table.HeaderCell collapsing>
                              <Button
                                floated="right"
                                primary
                                type="button"
                                size="small"
                                icon="add"
                                onClick={this.handleAddRow}
                              />
                            </Table.HeaderCell>
                          ) : null
                        }
                      </Table.Row>
                    </Table.Header>
                  :
                    (this.props.headerButtonNode && !this.state.isEditing ?
                      <Table.Header fullWidth>
                        <Table.Row>
                          <Table.HeaderCell colSpan={2}>
                            {this.props.headerButtonNode}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                    : null
                  )
                }
                <Table.Body>
                  {this.renderRow()}
                </Table.Body>
                {
                  this.checkIsEditing() ?
                    <Table.Footer fullWidth>
                      <Table.Row>
                        <Table.HeaderCell colSpan={2} />
                        <Table.HeaderCell collapsing>
                          <Button
                            floated="right"
                            primary
                            type="button"
                            size="small"
                            icon="add"
                            onClick={this.handleAddRow}
                          />
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Footer>
                  : null
                }
              </Table>
            </Segment>
          ) : null
        }
        {
          !newHeader ? (
            <Table
              style={this.props.tableStyle || {}}
              celled striped unstackable
              structured={!this.checkIsEditing()}
              selectable={this.checkIsEditing()}
              compact={this.checkIsEditing()}
            >
              {
                this.props.editable ?
                  <Table.Header fullWidth>
                    <Table.Row>
                      {
                        this.props.hideButton ? (
                          <Table.HeaderCell colSpan={2}>
                            {this.props.headerNode || t('Specifications')}
                          </Table.HeaderCell>
                        ) : (
                          <Table.HeaderCell colSpan={2}>
                            {(this.props.headerButtonNode && !this.state.isEditing)
                              && this.props.headerButtonNode
                            }
                            {
                              this.props.cancelNode && this.checkIsEditing() ?
                              this.props.cancelNode({
                                isEditing: this.state.isEditing,
                                onClick: this.handleOnCancel,
                              }) : null
                            }
                            {
                              !this.props.cancelNode && this.checkIsEditing() ? (
                                <Button
                                  as="a"
                                  size="small"
                                  floated="left"
                                  compact
                                  icon="remove"
                                  content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                                  onClick={this.handleOnCancel}
                                  disabled={this.props.loading}
                                />
                              ) : null
                            }
                            {
                              this.props.buttonNode && this.props.editable ?
                              this.props.buttonNode({
                                isEditing: this.state.isEditing,
                                onClick: this.handleOnConfirm,
                              }) : null
                            }
                            {
                              !this.props.buttonNode && this.props.editable ? (
                                <Button
                                  as="a"
                                  size="small"
                                  floated="right"
                                  compact
                                  onClick={this.handleOnConfirm}
                                  icon={this.checkIsEditing() ? 'save' : 'pencil'}
                                  color={this.checkIsEditing() ? 'blue' : null}
                                  content={t(this.checkIsEditing() ? 'Update' : 'Edit', { ns: TRANSLATION_FILES.translation })}
                                  disabled={this.props.loading}
                                />
                              ) : null
                            }
                          </Table.HeaderCell>
                      )}
                      {
                        this.checkIsEditing() ? (
                          <Table.HeaderCell collapsing>
                            <Button
                              floated="right"
                              primary
                              type="button"
                              size="small"
                              icon="add"
                              onClick={this.handleAddRow}
                            />
                          </Table.HeaderCell>
                        ) : null
                      }
                    </Table.Row>
                  </Table.Header>
                :
                  (this.props.headerButtonNode && !this.state.isEditing ?
                    <Table.Header fullWidth>
                      <Table.Row>
                        <Table.HeaderCell colSpan={2}>
                          {this.props.headerButtonNode}
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                  : null
                )
              }
              <Table.Body>
                {this.renderRow()}
              </Table.Body>
              {
                this.checkIsEditing() ?
                  <Table.Footer fullWidth>
                    <Table.Row>
                      <Table.HeaderCell colSpan={2} />
                      <Table.HeaderCell collapsing>
                        <Button
                          floated="right"
                          primary
                          type="button"
                          size="small"
                          icon="add"
                          onClick={this.handleAddRow}
                        />
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Footer>
                : null
              }
            </Table>
          ) : null
        }
      </div>
    );
  }
}

export default withTranslation(namespaces)(connect(SpecificationTable.mapStateToProps)(SpecificationTable));



// WEBPACK FOOTER //
// ./src/components/SpecificationTable.jsx